import { CommonModule } from '@angular/common';
import { Component, input, output } from '@angular/core';
import { FnfBaseDialog } from '../fnf-base-dialog/fnf-base-dialog';
import { FnfButtons } from '../fnf-buttons/fnf-buttons';

export interface DialogProps {
  title: string;
  description?: string;
  buttonText: string;
  [key: string]: any;
}

@Component({
  selector: 'app-fnf-success-dialog',
  imports: [CommonModule, FnfBaseDialog, FnfButtons],
  templateUrl: './fnf-success-dialog.html',
  styleUrl: './fnf-success-dialog.scss',
})
export class FnfSuccessDialog {
  visible = input<boolean>(false);

  dialogProps = input<DialogProps>({
    title: 'This is a default text',
    description: '',
    buttonText: 'Ok',
  });

  onClose = output<void>();

  getFormattedText(type: string): string {
    return this.dialogProps()[type]?.replace(/\\n/g, '<br>') || '';
  }

  close(): void {
    this.onClose.emit();
  }
}
